import React from 'react'

import SummaryScreen from '../../screens/SummaryScreen'

const Summary = () => {
  return <SummaryScreen />
}

export default Summary
